import { useState, useEffect, useMemo, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useImagenesPublicacion } from '../../hooks/useImagenesPublicacion'
import ComponenteError from '../publicaciones/ComponenteError'
import Publicacion from '../publicaciones/Publicacion'
import * as favoritosService from '../servicios/favoritosService'
import styles from './Favoritos.module.css'

const Favoritos = () => {
  const imagenesFetchKeyRef = useRef('')
  const [favoritos, setFavoritos] = useState([])
  const navigate = useNavigate()
  const { loginDataContext: { idUsuario } = {} } = useAuth()
  const { adjuntos, loadingImagenes, fetchImagenes } = useImagenesPublicacion()

  useEffect(() => {
    const fetchFavoritos = async () => {
      const userId = idUsuario
      if (!userId) return

      const { data: favoritos } = await favoritosService.buscarPorUsuario(userId)
      setFavoritos(favoritos.filter((fav) => fav.idVendedor !== parseInt(userId)))
    }

    fetchFavoritos()
  }, [idUsuario])
  const idsPublicacionesParaImagenes = useMemo(
    () => favoritos.map((p) => p.idPublicacion),
    [favoritos]
  )
  useEffect(() => {
    if (idsPublicacionesParaImagenes.length === 0) {
      return
    }

    const fetchKey = idsPublicacionesParaImagenes.join(',')
    if (imagenesFetchKeyRef.current === fetchKey) {
      return
    }

    imagenesFetchKeyRef.current = fetchKey
    fetchImagenes({ idPublicaciones: idsPublicacionesParaImagenes })
  }, [idsPublicacionesParaImagenes])
  const handleToggle = (event, favorito, idPublicacion) => {
    navigate(`/Publicacion/${idPublicacion}`)
  }

  const updateFavoritos = async (idpub) => {
    setFavoritos((prev) => prev.filter((pub) => pub.idPublicacion !== idpub))
  }

  return (
    <fieldset className={styles.fieldset}>
      <legend>Mis Favoritos</legend>
      <div className={styles.grid}>
        {favoritos.length > 0 ? (
          favoritos.map((publicacion) => (
            <Publicacion
              key={publicacion.idPublicacion}
              onToggleClick={handleToggle}
              publicacion={publicacion}
              compFavorito={true}
              onDelete={updateFavoritos}
              adjunto={adjuntos.find((a) => a.idPublicacion === Number(publicacion.idPublicacion))}
              loadingImagenes={loadingImagenes}
            />
          ))
        ) : (
          <div className={styles.vacio}>
            <ComponenteError tipo="i" idAviso={5} />
          </div>
        )}
      </div>
    </fieldset>
  )
}

export default Favoritos
